import React, { useState } from "react";

// "Photo: Jane Doe · CC BY-SA 4.0" for one image, or null when nothing was provided.
export function ImageCredit({ meta }) {
  if (!meta || (!meta.credit && !meta.license)) return null;
  return (
    <p className="image-credit">
      {meta.credit && <>Photo: {meta.credit}</>}
      {meta.credit && meta.license && " · "}
      {meta.license}
    </p>
  );
}

export default function ImageCarousel({ images, meta }) {
  const [current, setCurrent] = useState(0);

  if (!images || images.length === 0) return null;
  if (images.length === 1) {
    return (
      <>
        <img src={images[0]} alt="Ship" style={{ width: "100%" }} />
        <ImageCredit meta={meta?.[images[0]]} />
      </>
    );
  }

  const next = () => setCurrent((prev) => (prev + 1) % images.length);
  const prev = () => setCurrent((prev) => (prev - 1 + images.length) % images.length);

  return (
    <div className="carousel">
      <img src={images[current]} alt={`Ship ${current + 1}`} style={{ width: "100%" }} />
      <ImageCredit meta={meta?.[images[current]]} />
      <div className="carousel-controls">
        <button onClick={prev}>&lt;</button>
        <span>{current + 1}/{images.length}</span>
        <button onClick={next}>&gt;</button>
      </div>
    </div>
  );
}
